<ion-content class="ion-padding">
  <div class="flex flex-col gap-y-5">
    <h3>Reset Password</h3>
    
  <form #form>
      <ark-input
      class="my-3"
      name="password"
      type="password"
      label="New Password"
      [passwordValidate]="true"
      [error]="formGroup?.get('password')?.touched && formGroup?.get('password')?.invalid || false"
      [errorLabel]="'Password is required'"
      (valueChanged)="formControlChange('password', $event.value)"
    ></ark-input>
  </form>  

  <p class="w-full text-zinc-600 text-[13px] font-normal">
    The next time you log in, you will need to use your new password.
  </p>

  <ark-button (click)="resetPassword()">RESET</ark-button>
  </div>
</ion-content>
